import { useEffect, useState } from "react"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { RoutePath } from "../../../../../features/routes"
import { RoadmapForm } from "./roadmapForm"
import { useManagerHooks } from "../../../../manager"
import { useRoadmapLoaders } from "../../../loaders/roadmapLoaders"
import { SaleOperation } from "../../../../sales"
import { Delivery, DeliveryMethod, DeliveryOrder, DeliveryStatus, useDeliveryLoaders, useDeliveryOrderLoaders } from "../../../../deliveries"
import { Operation, useOperationLoaders } from "../../../../operations"

export const RoadmapFormLoader = () => {
  const [shipments, setShipments] = useState<Delivery[]>([])
  const [shipmentOrders, setShipmentOrders] = useState<DeliveryOrder[]>([])
  const [operations, setOperations] = useState<Operation[]>([])
  const [ready, setReady] = useState(false)

  const { currentBranchId } = useManagerHooks()

  const deliveryLoaders = useDeliveryLoaders()
  const operationLoaders = useOperationLoaders()
  const roadmapLoaders = useRoadmapLoaders()
  const deliveryOrderLoaders = useDeliveryOrderLoaders()

  const { setDisableBranchSelector } = useUIStateActions()

  const load = async () => {
    const options = {
      valueFilters: [
        { prop: 'branchId', value: currentBranchId! },
        { prop: 'method', value: DeliveryMethod.SHIPMENT },
        { prop: 'deliveryStatus', value: DeliveryStatus.PENDING },
        { prop: 'archived', value: true, equals: false },
        { prop: 'cancelled', value: true, equals: false }
      ]
    }
    const { loadDeliveriesBatch } = deliveryLoaders()
    // Always from the db: the cached deliveries may be only some of them (e.g. the ones of a roadmap opened before,
    // that are still pending), and then the ones without roadmap wouldn't be offered.
    // Annulled delivery notes keep their pending status, so they are excluded explicitly
    const loadedDeliveries = ((await loadDeliveriesBatch(options, false)).dataTypes as Delivery[])
      .filter(delivery => !delivery.cancelled)
    const { loadDeliveryOrders } = deliveryOrderLoaders()
    const loadedDeliveryOrders = await loadDeliveryOrders(loadedDeliveries.map(delivery => delivery.orderId!))
    setShipmentOrders(loadedDeliveryOrders)
    const { loadDeliveriesRoadmapsLinks } = roadmapLoaders()
    const loadedDeliveryRoadmaps = await loadDeliveriesRoadmapsLinks(loadedDeliveries.map(delivery => delivery.id), true)
    const pendingRoadmapShipments = loadedDeliveries.filter(delivery => !loadedDeliveryRoadmaps.find(deliveryRoadmap => deliveryRoadmap.deliveryId === delivery.id))
    setShipments(pendingRoadmapShipments)
    const { loadDeliveriesOperations } = operationLoaders()
    const loadedOperations = await loadDeliveriesOperations(loadedDeliveries) as SaleOperation[]
    setOperations(loadedOperations)    
  }

  useEffect(() => {
    setDisableBranchSelector(true)
    load().then(() => setReady(true))
    return () => {
        setDisableBranchSelector(false)
    }
  }, [currentBranchId])

  const crumbs = useGetCrumbs(
    'Hojas de Ruta',
    RoutePath.ROADMAPS,
    undefined,
    undefined,
    'Generar'
  )

  return (
    <PanelLoader
      title="Generar Hoja de Ruta"
      crumbs={crumbs}
      ready={ready}
    >
      <RoadmapForm
        shipments={shipments}
        shipmentOrders={shipmentOrders}
        operations={operations}
      />
    </PanelLoader>
  )
}
